export default class Sounds {
    private audioBuffers: Map<string, AudioBuffer> = new Map();
    private context = new AudioContext();
    private readonly EVENTS = ["touchstart", "touchmove", "pointerdown", "keydown", "scroll"];
    private masterGain: GainNode;
    constructor() {
        this.EVENTS.forEach((eventName) =>
            window.addEventListener(
                eventName,
                () => {
                    this.unlock();
                },
                { once: true },
            ),
        );

        this.masterGain = this.context.createGain();
        this.masterGain.gain.value = 0.125; // Set initial volume to 12.5%
        this.masterGain.connect(this.context.destination);
    }

    play(soundName: string, opts: { volume?: number } = {}) {
        try {
            const buffer = this.audioBuffers.get(soundName);
            if (!buffer) return;

            // Only skip if volume is exactly 0 (muted)
            if (this.masterGain.gain.value === 0) {
                return;
            }

            const source = this.context.createBufferSource();
            source.buffer = buffer;

            const gain = this.context.createGain();
            const volume = Math.max(0, Math.min(1, opts.volume ?? 1));
            gain.gain.value = volume;
            source.connect(gain).connect(this.masterGain);
            source.start();
        } catch (error) {
            // Silently fail audio playback to prevent breaking game functionality
            console.warn("Audio playback failed:", error);
        }
    }

    setMasterVolume(volume: number) {
        const clampedVolume = Math.max(0, Math.min(1, volume));
        this.masterGain.gain.value = clampedVolume;
    }
    unlock() {
        if (this.context.state === "suspended") this.context.resume();
    }
    async loadSound(soundName: string, url: string) {
        const res = await fetch(url);
        const arrayBuffer = await res.arrayBuffer();
        const audioBuffer = await this.context.decodeAudioData(arrayBuffer);
        this.audioBuffers.set(soundName, audioBuffer);
    }
}
